import { formatQuantity } from './formatQuantity';

/**
 * Whole kilograms. The payload keeps stored precision, but a modelled estimate
 * rendered to two decimals reads as a measured quantity, and on a row carrying
 * nothing else the rounding is what signals this is an estimate.
 */
export const formatKgCo2e = (
  value: number | string | null | undefined
): string | null => {
  if (value == null || String(value).trim() === '') return null;
  const amount = Number(value);
  if (!Number.isFinite(amount)) return null;
  return `${formatQuantity(Math.round(amount) || 0)} kg CO₂e`;
};
